var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h4',[_vm._v("Id: "+_vm._s(_vm.id))])])])}
var staticRenderFns = []

export { render, staticRenderFns }